<div class="chat-container" cdkDrag>

    
        <!-- Demo content -->
    <div style="text-align: center;" *ngIf="!isLive">
        <h1 style="margin-bottom: 20px;">Instance Management Dashboard</h1>
        <p style="color: #9ca3af;">Click the chat button in the bottom right to open the support chat.</p>
    </div>

    <!-- Chat Toggle Button -->
    <button class="chat-toggle" (click)="toggleChat()">
        <svg viewBox="0 0 24 24">
            <path d="M20 2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h4l4 4 4-4h4c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 12H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z"/>
        </svg>
    </button>

    <!-- Chat Popup -->
    <div class="chat-popup" id="chatPopup" [ngClass]="{'active': chat()}">
        <!-- Chat Header -->
        <div class="chat-header">
            <div>
                <h3 *ngIf="!isLive">Support Chat</h3>
                <h3 *ngIf="isLive">Yard Chat</h3>
                <div class="chat-status" [style.color]="isConnected ? 'green' : 'grey'">
                    <div class="status-dot"  [style.background-color]="isConnected ? 'green' : 'grey'"></div>
                    <span>Online</span>
                </div>
            </div>
            <!--
            <button class="close-chat" (click)="hideChat()">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
                </svg>
            </button>
            -->
        </div>

        <!-- Chat Messages -->
        <div class="chat-messages" id="chatMessages">
            <div class="message incoming">
                <div class="message-content" *ngIf="isLive">
                    Live chat
                </div>
                <div class="message-content" *ngIf="!isLive">
                    Hi! I'm here to help you with your instance management. How can I assist you today?
                </div>
                <div class="message-time">2:30 PM</div>
            </div>


            <!-- Quick Actions -->
            <div class="quick-actions" *ngIf="!isLive">
                <button class="quick-action" (click)="sendQuickMessage('How do I create a new instance?')">Create Instance</button>
                <button class="quick-action" (click)="sendQuickMessage('My instance is not starting')">Instance Issues</button>
                <button class="quick-action" (click)="sendQuickMessage('How much does it cost?')">Pricing</button>
                <button class="quick-action" (click)="sendQuickMessage('I need technical support')">Tech Support</button>
            </div>

            <div class="message" *ngFor="let chat of messages; let i = index;" [ngClass]="chat.status">
                 <div class="message-content">
                    {{ chat.text }}
                </div>
                <div class="message-time">{{ chat.timestamp | date }}</div>
            </div>

            <!-- Typing Indicator -->
            <div class="message bot">
                <div class="typing-indicator" id="typingIndicator" [ngClass]="{'active': isTyping}">
                    <div class="typing-dots">
                        <div class="typing-dot"></div>
                        <div class="typing-dot"></div>
                        <div class="typing-dot"></div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Chat Input -->
        <div class="chat-input">
            <div class="input-container">
                <textarea 
                    class="message-input" 
                    name="messageInput" 
                    [(ngModel)]="message"
                    placeholder="Type your message..."
                    rows="1"
                    (keydown)="handleKeyPress($event)"
                    (input)="adjustTextareaHeight($event)"
                ></textarea>
                <button class="send-button" id="sendButton" (click)="sendMessage()">
                    <svg viewBox="0 0 24 24">
                        <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"/>
                    </svg>
                </button>
            </div>
        </div>
    </div>
</div>